import { render, staticRenderFns } from "./AddEditMemberPatho.vue?vue&type=template&id=1c4a7650"
import script from "./AddEditMemberPatho.vue?vue&type=script&lang=js"
export * from "./AddEditMemberPatho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports